import React from 'react';
import ProfessionalPageWrapper from './Components/ProfessionalPageWrapper';
import AppPageWrapper from '../AppLayout/AppPageWrapper';
import { ListSection } from './Components/Firm/ListSection';
import FirmDetails from './Components/Firm/FirmDetails';
import { makeStyles } from '@material-ui/core';
import { hasApplicationFeature } from '../utils';
import { FEATURE_SHOW_FIRM_PAGE } from '../constants';
import { Redirect } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    claimSectionWrapper: {
        '& .MuiPaper-root:nth-child(2)': {
            marginTop: '-50px',
        },
    },
}));


export default function Firm(props) {
    const classes = useStyles();

    if (!hasApplicationFeature(FEATURE_SHOW_FIRM_PAGE)) {
        return <Redirect to="/404" />;
    }

    return (
        <div className={classes.claimSectionWrapper}>
            <ProfessionalPageWrapper {...props}>
                <FirmDetails {...props}/>
            </ProfessionalPageWrapper>

            <AppPageWrapper
                {...props}
                variant={'simpleForm'}
                header={null}
                className={classes.claimSectionWrapper}
            >
                <ListSection {...props}/>
            </AppPageWrapper>
        </div>
    );
}